import React, { useState } from 'react'
import { observer } from 'mobx-react'
import st from './PercentPage.module.scss'
import Loader from '../../ContentBox/Global/Loader/Loader'
import { useHistory } from 'react-router-dom'

const RadioButton = (props) => {
  return (
    <div className={st.buttonGroup}>
      {props.values &&
        props.values.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => props.objectChangeHandler(item.id, props.name)}
              className={`${st.buttonItem} ${props.selected === item.id ? st.selected : st.notSelected} ${
                index === 0
                  ? st.firstButton
                  : index === props.values.length - 1
                    ? st.lastButton
                    : ''
              }`}
            >
              {item.name}
            </div>
          )
        })}
    </div>
  )
}

const Button = ({ text, isPrimary, onClick }) => {
  return (
    <button
      className={`${st.customButton} ${isPrimary ? st.firstButton : st.secondaryButton}`}
      onClick={onClick}
    >
      {text}
    </button>
  )
}

const PercentPage = ({
  loading,
  salesAnalytics,
  maxQuantity,
  maxBudget,
  translate,
  averageDurationData,
}) => {
  const [selectedType, setSelectedType] = useState('quantity')
  const [activeButton, setActiveButton] = useState('By quantity')

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType)
    setSelectedType(buttonType === 'By budget' ? 'budget' : 'quantity')
  }
  const handleDealsCountClick = (item) => {
    if (!item.deals_ids || item.deals_ids.length === 0) {
      console.warn('Нет ID сделок для этого статуса')
      return
    }

    const dealsIds = item.deals_ids.join(',')
    const statusName = item?.name || `Статус ${item?.id}`
    const url = `/crm/new-deals/${item.id}?deals_ids=${dealsIds}&status_name=${encodeURIComponent(statusName)}`

    window.open(url, '_blank')
  }

  return (
    <div>
      <div className={st.container}>
        <div className={st.headerWithBtns}>
          {/*<RadioButton*/}
          {/*  values={pages}*/}
          {/*  like_obj={true}*/}
          {/*  objectChangeHandler={handlePageChange}*/}
          {/*  selected={selectedPage}*/}
          {/*  name={'pageSelector'}*/}
          {/*/>*/}
          <div className={st.buttonContainer}>
            <Button
              text={translate?.by_budget_tab}
              isPrimary={activeButton === 'By budget'}
              onClick={() => handleButtonClick('By budget')}
            />
            <Button
              text={translate?.by_quantity_tab}
              isPrimary={activeButton === 'By quantity'}
              onClick={() => handleButtonClick('By quantity')}
            />
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          salesAnalytics?.map((item, index) => {
            const statusName = item?.name || `Статус ${item?.id}`
            const color = item?.color?.body_color || '#DFE6E9'
            const dealsCount = item?.deals_count || 0
            const budget = item?.budget || 0
            const avgDays = item?.avg_days || 0

            const quantityPercent = Math.round(
              (dealsCount / (maxQuantity || 1)) * 100,
            )
            const budgetPercent = Math.round((budget / (maxBudget || 1)) * 100)

            const percentage =
              selectedType === 'quantity' ? quantityPercent : budgetPercent

            return (
              <div className={st.containerForDeal} key={index}>
                <div
                  className={st.funnelName}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDealsCountClick(item)}
                >
                  {statusName}
                </div>
                <div className={st.progressBarAndCounts}>
                  <div
                    className={st.progressBar}
                    style={{
                      width: `${percentage}%`,
                      backgroundColor: color,
                    }}
                  >
                    {`${percentage}%`}
                  </div>
                  <div className={st.transactions}>
                    <div className={st.transactionsBudget}>
                      <div
                        className={st.count}
                        onClick={() => handleDealsCountClick(item)}
                        style={{ cursor: 'pointer' }}
                      >
                        {dealsCount}
                      </div>
                      <div className={st.text}>
                        {translate?.transactions_field}
                      </div>
                      <div className={st.count}>{budget}₸</div>
                    </div>
                    <div className={st.day}>{avgDays} d.</div>
                  </div>
                </div>
                <div className={st.days}>{avgDays} d.</div>
              </div>
            )
          })
        )}
        {!loading ? (
          <div className={st.duration}>
            <div className={st.number}>{averageDurationData} д.</div>
            <div className={st.text}>Средняя длительность сделки</div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default observer(PercentPage)
